// Roguelike map generator - 20 floors, mid-boss @ F10, final boss @ F20.

import { makeRng } from './rng';

export const NODE_TYPES = {
  MONSTER: 'monster',
  ELITE: 'elite',
  SHOP: 'shop',
  REST: 'rest',
  EVENT: 'event',
  BOSS: 'boss',
  MID_BOSS: 'mid_boss',
  SHRINE: 'shrine',
  TREASURE: 'treasure',
};

export const MAP_LENGTH = 20;
export const MID_BOSS_FLOOR = 10;

export function generateMap(seed) {
  const rng = makeRng(seed + '-map');
  const floors = [];
  for (let f = 0; f < MAP_LENGTH; f++) {
    if (f === MAP_LENGTH - 1) {
      floors.push([{ type: NODE_TYPES.BOSS, id: `f${f}-boss` }]);
      continue;
    }
    if (f === MID_BOSS_FLOOR - 1) {
      floors.push([{ type: NODE_TYPES.MID_BOSS, id: `f${f}-midboss` }]);
      continue;
    }
    // Force rest before boss
    if (f === MAP_LENGTH - 2) {
      floors.push([
        { type: NODE_TYPES.REST, id: `f${f}-rest` },
        { type: NODE_TYPES.SHOP, id: `f${f}-shop` },
      ]);
      continue;
    }
    // Force rest before mid-boss
    if (f === MID_BOSS_FLOOR - 2) {
      floors.push([
        { type: NODE_TYPES.REST, id: `f${f}-rest` },
        { type: NODE_TYPES.SHOP, id: `f${f}-shop` },
      ]);
      continue;
    }
    // Special treasure floor after mid-boss
    if (f === MID_BOSS_FLOOR) {
      floors.push([{ type: NODE_TYPES.TREASURE, id: `f${f}-treasure` }]);
      continue;
    }
    const choiceCount = 2 + (rng() > 0.4 ? 1 : 0);
    const opts = [];
    for (let c = 0; c < choiceCount; c++) {
      let type;
      if (f === 0) type = NODE_TYPES.MONSTER;
      else if (f === 3 || f === 7 || f === 13 || f === 17) {
        type = c === 0 ? NODE_TYPES.ELITE : NODE_TYPES.MONSTER;
      } else {
        const r = rng();
        if (r < 0.45) type = NODE_TYPES.MONSTER;
        else if (r < 0.60) type = NODE_TYPES.EVENT;
        else if (r < 0.72) type = NODE_TYPES.SHOP;
        else if (r < 0.82) type = NODE_TYPES.REST;
        else if (r < 0.90) type = NODE_TYPES.ELITE;
        else if (r < 0.96) type = NODE_TYPES.SHRINE;
        else type = NODE_TYPES.TREASURE;
      }
      opts.push({ type, id: `f${f}-${c}` });
    }
    floors.push(opts);
  }
  return floors;
}
